<script>

import 'bootstrap-vue/dist/bootstrap-vue.css'
import functions from '../../mixins/import/summary.js';

export default {
	mixins: [functions],
	props: ['id', 'rows', 'mappedColumns'],
	data() {
		return {

			fields: [
				{ key: 'code', label: 'Code', sortable: true, sortDirection: 'asc' },
				{ key: 'original_price', label: 'Original price', sortable: true, sortDirection: 'asc' },
				{ key: 'current_price', label: 'Current price', sortable: true, sortDirection: 'asc' },
				{ key: 'first_name', label: 'First name', sortable: true, sortDirection: 'asc' },
				{ key: 'last_name', label: 'Last name', sortable: true, sortDirection: 'asc' },
				{ key: 'email', label: 'Email', sortable: true, sortDirection: 'asc' },
				{ key: 'expires_at', label: 'Expires at', sortable: true, sortDirection: 'asc' }
			],

			copied_fields: [],

			totalRows: 0,
			currentPage: 1,
			search: null,
			sortBy: 'code',
			sortDesc: false,
			perPage: 15
		}
	},
	mounted() {

		if (this.mappedColumns.includes('original_price') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'original_price');
		}

		if (this.mappedColumns.includes('name') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'first_name');

			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'last_name');
		}

		if (this.mappedColumns.includes('email') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'email');
		}

		if (this.mappedColumns.includes('expires_at') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'expires_at');
		}


		this.totalRows = this.rows.length;
	},
	methods: {
		downloadFile()
		{
			let open = window.open('/import/' + this.id + '/download-file', '_blank');

			if (open == null || typeof(open) === 'undefined') {
				alert('Turn off your pop-up blocker!');
			}
		}
	}
}
</script>